@if (isVisible) {
  <div class="cookie-banner-overlay">
    <div class="cookie-banner-card">
      <div class="cookie-content">
        <h3>{{ 'pages.shared.cookie-banner.cookie-banner.text001' | translate }}</h3>
        <p class="cookie-subtitle">{{ 'pages.shared.cookie-banner.cookie-banner.text002' | translate }}</p>
        <p class="cookie-desc">
          {{ 'pages.shared.cookie-banner.cookie-banner.extra001' | translate }}
        </p>
      </div>
      
      <div class="cookie-actions">
        <button class="btn-cookie btn-reject" (click)="rejectAll()">{{ 'pages.shared.cookie-banner.cookie-banner.text003' | translate }}</button>
        <button class="btn-cookie btn-accept" (click)="acceptAll()">{{ 'pages.shared.cookie-banner.cookie-banner.text004' | translate }}</button>
      </div>
    </div>
  </div>
}